const useMainCTACopy = mainCTA => {
  if (!mainCTA) {
    return undefined;
  }
  let ctaLabelId = '';
  let ctaLabel = '';
  const ctaExperiment = mainCTA;
  const activeVariant = ctaExperiment?.activeVariant;
  if (activeVariant) {
    ctaLabel = activeVariant.label;
    ctaLabelId = activeVariant?.i18nId || 'createAccountCta.signUp';
  } else {
    const ctaLink = mainCTA;
    ctaLabel = ctaLink?.label;
    ctaLabelId = ctaLink?.i18nId || 'createAccountCta.signUp';
  }
  if (!ctaLabel) {
    return undefined;
  }
  const mainCTACopy = {
    id: ctaLabelId,
    defaultMessage: ctaLabel
  };
  return mainCTACopy;
};
export { useMainCTACopy as default };
//# sourceMappingURL=useMainCTACopy.js.map
